import React from 'react';
import { withStyles, ButtonBase, Input } from '@material-ui/core';


import { withRouter } from 'react-router-dom';
import Swiper from 'react-id-swiper';
import Apis from '../../network/Apis';
import 'swiper/swiper.less'
import './home.css' 




class SlideBanner extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            index: 0,
            bannerDatas: [],
        };
        this.params = {
            slidesPerView: 'auto',
            spaceBetween: 20,
            direction: 'horizontal',
            loop: true,
            centeredSlides: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,

              }
        };
    }

    componentDidMount() {
        this.getBanners()
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getBanners = async () => {
        let result = await Apis.encryptionBanner(); 
        if (result.code == 200) {
            this.setState({ bannerDatas: result.data });
        }
    }

    _onAdClick(item) {
        if (item.jump_type && item.jump_type != "") {
            if (item.jump_type == 1) {
                var a = document.createElement('a');
                a.setAttribute('href', item.jump_url);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } else if (item.jump_type == 2) {
                this.props.history.push({ pathname: '/play/' + item.jump_room_id + '/' + item.type_id + '/' + item.jump_event_id, data: item })
            } else if (item.jump_type == 3) {
                this.props.history.push({ pathname: '/play/' + item.jump_room_id + '/' + item.type_id + '/' + item.jump_event_id, data: item })
            }
        }
    }



    render() {
        const { bannerDatas } = this.state;
        const { classes } = this.props;
        return (
            <div className='homeListfoltbox'>
                {
                    bannerDatas && bannerDatas.length > 0 && <Swiper {...this.params}  >
                        {
                            bannerDatas.map((item, i) => (
                                <ButtonBase key={i} className={classes.bannerItem} onClick={() => this._onAdClick(item)}>
                                    <img src={item.cover} className={classes.bannerImg} alt='banner'></img>
                                </ButtonBase>
                            ))
                        }

                    </Swiper>
                }
                <div className='homeListfolt'></div>

            </div>

        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100vw',
        height: 230,
        backgroundSize: '100% 100%',
        padding: theme.spacing(1, 0, 0, 0),
        backgroundColor: 'white'
    },
    bannerItem: {
        padding: theme.spacing(0, 0, 0, 0),
        width: "calc(100vw)",
        height: 230,
        color: theme.palette.secondary.main,
    },
    bannerImg: {
        width: "calc(100vw)",
        height: 230,
        objectFit: 'cover',
        // backgroundColor:'#e6e6e6'
        // borderTopLeftRadius: 10,
        // borderTopRightRadius: 10
    },
}))(SlideBanner));